export enum FeatureFlags {
    AI_PRODUCT_ASSISTANT = 'aiProductAssistant',
    INTERCOM = 'intercom',
    SIMULATION = 'simulation',
    WIRE_SIZING = 'wireSizing',
    BULK_UPLOAD = 'bulkUpload',
    QUOTES = 'quotes',
    OEM_SUBSCRIPTION = 'oemSubscription',
    PROFILE_ENRICHMENT = 'profileEnrichment',
    FAULT_SIMULATIONS = 'faultSimulations',
    ARC_FAULT_MODEL = 'arcFaultModel',
    PROTECTION_TRIPPING = 'protectionTripping',
    SIGN_OFF = 'signOff',
    STATE_OF_CHARGE_DERATING = 'stateOfChargeDerating',
    PORT_SCALE = 'portScale',
}
